var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8.5C3 6.91449 4.05425 5.57522 5.5 5.14494V3.66667C5.5 3.1625 5.91249 2.75 6.41666 2.75C6.92083 2.75 7.33333 3.1625 7.33333 3.66667V5.09981C8.864 5.47367 10 6.85417 10 8.5C10 10.1458 8.864 11.5263 7.33333 11.9002L7.33333 18.3333C7.33333 18.8375 6.92083 19.25 6.41666 19.25C5.91249 19.25 5.49999 18.8375 5.49999 18.3333L5.49999 11.8551C4.05425 11.4248 3 10.0855 3 8.5ZM4.83 8.5C4.83 7.57768 5.57768 6.83 6.5 6.83C7.42232 6.83 8.17 7.57768 8.17 8.5C8.17 9.42232 7.42232 10.17 6.5 10.17C5.57768 10.17 4.83 9.42232 4.83 8.5Z",
    fill: "#04B7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.5C12 11.8542 13.136 10.4737 14.6667 10.0998V3.66667C14.6667 3.1625 15.0792 2.75 15.5833 2.75C16.0875 2.75 16.5 3.1625 16.5 3.66667L16.5 10.1449C17.9457 10.5752 19 11.9145 19 13.5C19 15.0855 17.9457 16.4248 16.5 16.8551V18.3333C16.5 18.8375 16.0875 19.25 15.5833 19.25C15.0792 19.25 14.6667 18.8375 14.6667 18.3333V16.9002C13.136 16.5263 12 15.1458 12 13.5ZM13.83 13.5C13.83 12.5777 14.5777 11.83 15.5 11.83C16.4223 11.83 17.17 12.5777 17.17 13.5C17.17 14.4223 16.4223 15.17 15.5 15.17C14.5777 15.17 13.83 14.4223 13.83 13.5Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/FiltersIcon.2243b65f788a3f129753b4d2cdf6d603.svg";
export { ForwardRef as ReactComponent };